module.exports = __webpack_public_path__ + "static/media/hder_mobile_img.fae40798.png";